import './Layout.css';
import Top from './Top'
import NotFound from './NotFound';
//import Day1 from './Article/Posts/day1';
import Information from './components/siteInformation';
import Footer from './components/Footer';
import Article from './components/Article'
import PostDate from './Article/Posts/Posts.json'

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React from 'react';
import { motion, AnimatePresence } from "framer-motion";

export default class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      siteName: "地下訪問日記",
      siteAuthor: "Eito Kochi & KinakoCake"
    }
  }

  
  render() {
    return (
      <>
        <BrowserRouter basename={"/DB2web/2021/summer/12061040/"}>
          
          <Information siteName={this.state.siteName} siteAuthor={this.state.siteAuthor} />

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.25, ease: "easeIn" }}
          >
            <AnimatePresence exitBeforeEnter initial={true}>

              <Switch>
                <Route exact path="/">
                  <Top siteName={this.state.siteName} />
                </Route>
                
                {Object.keys(PostDate).map((posts) => {
                  console.log(posts)
                  return(
                    <Route path={`/posts/Day${posts}`} render={(props) => <Article siteName={this.state.siteName} id={posts} {...props} />} />
                    )
                })}
                <Route>
                  <NotFound />
                </Route>
              </Switch>

              <Footer siteAuthor={this.state.siteAuthor} />

            </AnimatePresence>
          </motion.div>

        </BrowserRouter>
      </>
    )
  }

}


/*
Dynamic Route(React Route 標準)
<Route path="/posts/day:id" render={(props) => <Article siteName={this.state.siteName} {...props} />}/>
*/